import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: '22681208-4467-487a-9820-c4640bfecba7',
    clientToken: 'pub568e213733cb69ebef97c28e858c8854',
    site: 'datadoghq.com',
    service: 'registration-portal',
    env: window.location.host.includes('.prod.') ? 'prod' : 'dev',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    // Masks all text
    defaultPrivacyLevel: 'mask',
});
